import { render, staticRenderFns } from "./riskAnalysisChart.vue?vue&type=template&id=d13a388c&"
import script from "./riskAnalysisChart.vue?vue&type=script&lang=js&"
export * from "./riskAnalysisChart.vue?vue&type=script&lang=js&"
import style0 from "./riskAnalysisChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports